import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgInvoice(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="11 8 38 44"
      fill="none"
      {...props}
    >
      <path
        fill={props.primaryColor}
        d="M47 13.333v22.644c.001.438-.072.872-.214 1.276a3.4 3.4 0 0 1-.617 1.08l-9.086 10.69a2.8 2.8 0 0 1-.918.725 2.45 2.45 0 0 1-1.084.252H15.833c-.751 0-1.472-.351-2.003-.976S13 47.55 13 46.667V13.333c0-.884.299-1.732.83-2.357S15.082 10 15.833 10h28.334c.751 0 1.472.351 2.003.976s.83 1.473.83 2.357M15.833 46.667H34.25v-10c0-.442.15-.866.415-1.179.266-.312.626-.488 1.002-.488h8.5V13.333H15.833zm21.25-8.334v5.98l5.08-5.98z"
      />
      <path
        fill={props.secondaryColor}
        stroke={props.secondaryColor}
        d="M27.745 23.078c0 .345.28.624.624.624h7.967a.624.624 0 1 0 0-1.247h-7.967a.625.625 0 0 0-.624.623ZM23 29.428c0 .345.28.624.624.624H36.1a.624.624 0 1 0 0-1.248H23.624a.626.626 0 0 0-.624.624ZM23 35.304c0 .276.163.5.364.5h7.272c.201 0 .364-.224.364-.5s-.163-.5-.364-.5h-7.272a.32.32 0 0 0-.257.146.6.6 0 0 0-.107.354ZM23.524 17.142c.29 0 .523.23.523.513v.77c.865 0 1.57.616 1.57 1.371a.52.52 0 0 1-.524.514.52.52 0 0 1-.523-.514c0-.163-.215-.343-.523-.343H23c-.309 0-.524.18-.524.343v.855c0 .163.215.343.524.343h1.046c.865 0 1.57.615 1.57 1.37v.855c0 .755-.705 1.37-1.57 1.37v.775l-.004.004a.52.52 0 0 1-1.038.01L23 25.377v-.788c-.866 0-1.57-.615-1.57-1.37 0-.284.235-.514.524-.514s.522.23.522.514c0 .163.215.343.524.343h1.046c.308 0 .523-.18.523-.341v-.857c0-.163-.215-.342-.523-.342H23c-.866 0-1.57-.616-1.57-1.37v-.856c0-.755.704-1.37 1.57-1.37v-.77c0-.284.234-.514.523-.514Z"
      />
    </svg>
  );
}
export default SvgInvoice;
